<aside
  sk-panel-view
  size="lg"
>
<header><h3>{{ notification.name }}</h3></header>
  <div class="sk-panel-content">
    <div class="sk-panel-scroll px-150">
      <div class="mb-150">
        <h4 class="mb-50">{{ 'sk-notifications-admin-center.notifications-panel.severity' | translate }}</h4>
        <div class="d-flex align-items-center line-height-24">
          <i class="material-icons md-22 me-2 {{ eventSeverityToIconClass.get(notification.severity) }}">
            {{eventSeverityToIconName.get(notification.severity)}}
          </i>
          <span class="col-sm-9 text-truncate">{{ notification.severity }}</span>
        </div>
      </div>
      <div class="mb-150">
        <h4 class="mb-50">{{ 'sk-notifications-admin-center.notifications-panel.category' | translate }}</h4>
        <div class="row line-height-24">
          <span class="col-sm-9 text-truncate">{{ notification.category }}</span>
        </div>
      </div>
      <div class="mb-150">
        <h4 class="mb-50">{{ 'sk-notifications-admin-center.notifications-panel.subject' | translate }}</h4>
        <div class="row line-height-24">
          <div
            class="col-sm-9"
            style="line-height: 1.5; white-space: pre-line; overflow-wrap: break-word"
            [innerHTML]="safeSubjectHtml">
          </div>
        </div>
      </div>
      <div class="mb-150">
        <h4 class="mb-50">{{ 'sk-notifications-admin-center.notifications-panel.body' | translate }}</h4>
        <div class="row line-height-24">
          <div
            class="col-sm-9"
            style="line-height: 1.5; white-space: pre-line; overflow-wrap: break-word"
            [innerHTML]="safeBodyHtml">
          </div>
        </div>
      </div>
    </div>
  </div>
</aside>
